"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Flex, useMultiStyleConfig } from "@chakra-ui/react";
import { VisualBlockColors, VisualBlockSizes, CaretSide, } from "./VisualBlock.types";
import { Illustration } from "../../atoms";
import { PROD_CDN_BASE_URL } from "../../helpers";
function getIllustrationW(size) {
    switch (size) {
        case VisualBlockSizes.SM:
            return "96px";
        case VisualBlockSizes.LG:
            return "240px";
        case VisualBlockSizes.XL:
            return "320px";
        case VisualBlockSizes.MD:
        default:
            return "140px";
    }
}
const VisualBlock = (_a) => {
    var { size = VisualBlockSizes.MD, bgColor = VisualBlockColors.RED, caretIn = true, caretSide = CaretSide.BOTTOM, illustrationId } = _a, rest = __rest(_a, ["size", "bgColor", "caretIn", "caretSide", "illustrationId"]);
    const styles = useMultiStyleConfig("VisualBlock", {
        size,
        bgColor,
        caretSide,
        caretIn,
    });
    return (_jsx(Flex, Object.assign({ sx: styles.mainContainer }, { children: _jsx(Illustration, Object.assign({ illustrationId: illustrationId, cdnUrl: `${PROD_CDN_BASE_URL}/illustrations/`, w: getIllustrationW(size) }, rest)) })));
};
VisualBlock.displayName = "VisualBlock";
export default VisualBlock;
//# sourceMappingURL=VisualBlock.js.map